import { useRef, useState, useEffect } from "react";
import Button from "./ui-blocks/elements/button";
import CarouselCard2 from "./ui-blocks/carouselCards/carouselCard2";
import CarouselCard5 from "./ui-blocks/carouselCards/carouselCard5";
import CarouselCard8 from "./ui-blocks/carouselCards/carouselCard8";
import CarouselCard10 from "./ui-blocks/carouselCards/carouselCard10";
import CarouselCard11 from "./ui-blocks/carouselCards/carouselCard11";
import CarouselCard13 from "./ui-blocks/carouselCards/carouselCard13";
import CarouselCard14 from "./ui-blocks/carouselCards/carouselCard14";

// Swiper imports
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/free-mode';
import GeneralCarouselCard from "./ui-blocks/carouselCards/generalCarouselCard";
import {StartupTrainerImage} from "../../assets";

export default function CarouselComponent(props) {
    const swiperRef = useRef(null);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [progressPercent, setProgressPercent] = useState(10); // Start with half of first section (1.5/15 = 10%)
    const totalSlides = 11; // total number of slides

    // Define the tab labels and their corresponding slide ranges
    const tabs = [
        { name: "Team", startIndex: 0, endIndex: 1 },   // Slides 0,1
        { name: "Startup Trainer", startIndex: 2, endIndex: 3 },       // Slides 2,3
        { name: "Design, Develop, and Deploy", startIndex: 4, endIndex: 5 },     // Slides 4,5
        { name: "Deployment Day", startIndex: 6, endIndex: 7 },         // Slides 6,7
        { name: "Conclusion", startIndex: 8, endIndex: 9 },          // Slides 8,9
    ];

    // Handle tab click
    const handleTabClick = (index) => {
        if (swiperRef.current) {
            swiperRef.current.slideTo(tabs[index].startIndex);
        }
    };

    // Update active tab and progress based on current slide index
    const handleSlideChange = (swiper) => {
        const currentIndex = swiper.realIndex;
        // Update progress bar
        setProgressPercent(((currentIndex + 1) / totalSlides) * 100);
        // Update active tab
        const activeTab = tabs.findIndex(
            (tab) => currentIndex >= tab.startIndex && currentIndex <= tab.endIndex
        );
        if (activeTab !== -1) {
            setActiveTabIndex(activeTab);
        }
    };

    return (
        <div>
            <div className="bg-gray-100 theme-dark bg-color bg-pattern _none pt-6 mb-5">
                {/* Title and tabs - constrained inside a normal container */}
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            {/* The decorative arrow icon is moved outside this container, placed later */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 position-relative">
                            <div className="row align-items-end">
                                <div className="col">
                                    <h2 className="fw-normal mb-0 text-6xl">
                                        <strong>Journey</strong> of <strong>Education</strong> at Extern Academy
                                    </h2>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 pt-4 p-2">
                            <div className="swiper-tabs position-relative d-flex pfs-4 fw-bold mb-lg-5">
                                <div className="swiper-pagination bg-transparent"></div>
                                <div className="overflow-x-auto w-100 d-block position-relative swiper-pagination-custom-wrapper">
                                    <ul className="swiper-pagination-custom d-flex flex-nowrap flex-lg-wrap list-unstyled text-center mt-3 gap-5 justify-content-between">
                                        {tabs.map((tab, index) => (
                                            <li
                                                key={index}
                                                className={`col-auto col-lg swiper-pagination-switch cursor-pointer ${
                                                    activeTabIndex === index ? 'active' : ''
                                                }`}
                                                onClick={() => handleTabClick(index)}
                                            >
                                                <button className="btn-link switch-title border-0 bg-transparent fw-bold text-decoration-none text-nowrap">
                                                    {tab.name}
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                    {/* Progress bar that thickens as you advance through slides */}
                                    <div className="progress-bar-container brand-color" style={{ height: '4px', background: '#ddd', marginTop: '8px' }}>
                                        <div
                                            className="progress-bar-fill"
                                            style={{
                                                width: `${progressPercent}%`,
                                                height: '100%',
                                                background: '#3769B9',
                                                transition: 'width 0.3s ease'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Full-width carousel section */}

                <div className="container-fluid px-0 position-relative">
                    {/* Decorative arrow - positioned relative to this full-width container */}
                    <i className="icon icon-arrow-04 d-none d-lg-block position-absolute z-0" role="presentation">
                        <svg role="img" xmlnsXlink="http://www.w3.org/1999/xlink" fill="currentColor" viewBox="0 0 20 20">
                            <use xlinkHref="#arrow-04"></use>
                        </svg>
                    </i>

                    {/* Swiper with incremental swiping */}
                    <div className="">
                        <Swiper
                            modules={[Pagination, Navigation, FreeMode]}
                            spaceBetween={0}                    // No gap between slides
                            slidesPerView={1.2}                  // 20% peek of next slide
                            centeredSlides={true}
                            freeMode={true}
                            freeModeMomentum={true}               // Enable momentum for natural feel
                            freeModeSticky={true}                  // Snap after momentum
                            speed={800}                            // Slower transition
                            touchEventsTarget="container"          // Ensure touch works everywhere
                            grabCursor={true}                      // Show grab cursor on desktop
                            simulateTouch={true}                    // Enable touch simulation
                            touchRatio={1}                          // Normal touch sensitivity
                            pagination={{ clickable: true, dynamicBullets: true }}
                            navigation={{
                                prevEl: '.swiper-button-prev',
                                nextEl: '.swiper-button-next',
                            }}
                            onSwiper={(swiper) => (swiperRef.current = swiper)}
                            onSlideChange={handleSlideChange}
                            style={{ width: '100%' }}
                        >
                            <div className="">
                                <SwiperSlide>{card4()}</SwiperSlide>
                                <SwiperSlide><CarouselCard5 /></SwiperSlide>

                                <SwiperSlide>{card1()}</SwiperSlide>
                                <SwiperSlide><CarouselCard2 /></SwiperSlide>

                                {/* TODO: Delete this  */}
                                {/*<SwiperSlide><CarouselCard3 /></SwiperSlide>*/}


                                {/* TODO: Delete this  */}
                                {/*<SwiperSlide><CarouselCard6 /></SwiperSlide>*/}

                                <SwiperSlide>{card5()}</SwiperSlide>
                                <SwiperSlide><CarouselCard8 /></SwiperSlide>

                                {/* TODO: Delete this  */}
                                {/*<SwiperSlide><CarouselCard9 /></SwiperSlide>*/}

                                <SwiperSlide><CarouselCard10 /></SwiperSlide>
                                <SwiperSlide><CarouselCard11 /></SwiperSlide>

                                {/* TODO: Delete this  */}
                                {/*<SwiperSlide><CarouselCard12 /></SwiperSlide>*/}

                                <SwiperSlide><CarouselCard13 /></SwiperSlide>
                                <SwiperSlide><CarouselCard14 /></SwiperSlide>
                            </div>
                        </Swiper>
                    </div>

                    {/* Mobile pagination (optional) */}
                    <div className="d-md-none swiper-pagination-bullets position-static py-4 py-lg-5 bottom-0 d-flex justify-content-center flex-row top-100 d-lg-none swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal"></div>

                    {/* Navigation buttons - positioned absolute within this container */}
                    <div className="col-auto position-absolute swiper-buttons-container">
                        <div className="swiper-buttons d-flex justify-content-end swiper-buttons-centered">
                            <button
                                className="btn btn-lg btn-outline-gray-500 swiper-button-prev rounded-circle position-absolute"
                                aria-label="Previous" title="Previous Slide"
                            >
                                <span className="material-symbols-outlined fs-5 position-relative">arrow_back</span>
                            </button>
                            <button
                                className="btn btn-lg btn-outline-gray-500 swiper-button-next rounded-circle position-absolute"
                                aria-label="Next"
                                title="Next Slide"
                            >
                                <span className="material-symbols-outlined fs-5 position-relative">arrow_forward</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    function card1() {
        return (
            <GeneralCarouselCard
                title="Startup Trainer"
                blurb="It costs too much to be an innovator, when the road has already been paved. In their early years, our Startup Trainers unleashed their inner Picasso and Einstein, achieving paramount success attributed to their outstanding effort. The Startup Trainer's responsibility is to train each member of the team, and ensure the team deploys before Demo Day."
                primaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/misc/atlas-carries-the-earth.webp"
                primaryImageALT="In Motion"
                secondaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/misc/atlas-demigod.webp"
                secondaryImageURL={StartupTrainerImage}
                secondaryImageALT="In Nature"
                primaryButtonRow={<Button text="EXPLORE THE STARTUP TRAINER" ctaURL="/education/trainer" target="_blank" rel="noopener noreferrer" noPadding={true}  />}
            />
        )
    }

    function card4() {
        return (
            <GeneralCarouselCard
                title="Team Structure & Collaboration"
                blurb="A complete team is made of 10 externs. Each member is assigned a distinct role such Chief Creative Officer, Chief Technical Officer, Chief Executive Officer. Teams meet two times per week to touch base and demo progress. All communication happens through Slack and Zoom. We create an environment where students learn to think big, collaborate effectively, and turn ideas into reality."
                primaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/misc/bronze-fasces-detail.webp"
                primaryImageALT="ES Students Playing"
                secondaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/misc/alexander-the-great.webp"
                secondaryImageALT="es sprinklers"
                primaryButtonRow={<Button text="HOW TO APPLY" ctaURL="/admissions" target="_blank" rel="noopener noreferrer" noPadding={true}  />}
            />
        )
    }

    function card5() {
        return (
            <GeneralCarouselCard
                title="Design, Develop, and Deploy"
                blurb="Sample different positions to find your best fit. Teams adopt professional business practices to design, develop, and deploy a free consumer app available to the public. Prioritizing deployment gives you a deeper, hands-on understanding of how startups really work."
                primaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/misc/5d02046c4cf2703a464085cc.webp"
                primaryImageALT="ES Students Playing"
                secondaryImageURL="https://storage.googleapis.com/extern-academy.firebasestorage.app/images/misc/g2cm_fi978_learn_article_images_-5bgraphic_design-5d_v1b.webp"
                secondaryImageALT="es sprinklers"
                primaryButtonRow={<Button text="EXPLORE RESOURCES" ctaURL="/education/definitions" target="_blank" rel="noopener noreferrer" noPadding={true}  />}
            />
        )
    }
}